import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'ColorInputUnit'
}

import { NInput } from 'naive-ui'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: null,
    inputValue: null,
    handleChange: null,
    handleUpdateValue: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NInput), {
    size: "small",
    placeholder: __props.label,
    value: __props.inputValue.toUpperCase(),
    onChange: __props.handleChange,
    "onUpdate:value": __props.handleUpdateValue
  }, null, 8, ["placeholder", "value", "onChange", "onUpdate:value"]))
}
}

})